import React from "react";
import { connect } from "react-redux";
import PaymentModalWithoutStripe from "./paymentModalWithoutStripe";
import { noCartBalance } from "../../cart/cart.selectors.v2";
import { changePromoCode, clearPromo } from "../../cart/cart.actions";

class PaymentModalContainer extends React.Component {
  componentWillUnmount() {
    const {
      props: { clearPromo, changePromoCode }
    } = this;
    clearPromo();
    changePromoCode("");
  }

  render() {
    const { noCartBalance } = this.props;

    if (noCartBalance === undefined || noCartBalance === null) return <></>;

    return <PaymentModalWithoutStripe noCartBalance={noCartBalance} />;
  }
}

const mapStateToProps = state => ({
  noCartBalance: noCartBalance(state)
});

const mapDispatchToProps = dispatch => ({
  changePromoCode: val => dispatch(changePromoCode(val)),
  clearPromo: () => dispatch(clearPromo())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentModalContainer);
